import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonModal from "Components/CommonModal";
import MarkImageNameEditModal from "Components/Agencies/MarkImageNameEditModal";
import AddApplicationTypeModal from "Components/Agencies/AddApplicationTypeModal";
import {
  FileText,
  Download,
  Edit,
  Image,
  X,
  Copy,
  ExternalLink,
} from "lucide-react";
import {
  editProgress,
  editPaidStatus,
  getAgenciesDetail,
  downloadPrivacyFile,
  getFileDownload,
  getAddPayment,
  getStamp,
  getAttorney,
  addCustomerNumber,
  createFileLink,
  getAgencyUploadFile,
  deleteAgencyFile,
  getResizeFileDownload,
  editTaxInvoiceStatus,
} from "JS/API";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { paidStatusList, newStatusList } from "JS/array";

import PaymentModal from "Components/PaymentModal";
import ApplicationNumberModal from "Components/ApplicationNumberModal";
import FloatingList from "Components/FloatingList";
import PaymentEditModal from "Components/PaymentEditModal";
import ApplyHistoryModal from "Components/ApplyHistoryModal";
import ApplicationForm from "Components/ApplicationForm";
import ImageGenerateFloat from "Components/ImageGenerateFloat";import RefundModal from "Components/Agencies/RefundModal";
import { detailPageStyles, listPageStyles } from "utils/designSystem";

const ApplicationDetail = () => {
  const [info, setInfo] = useState({});
  const [info_applicant, setInfo_applicant] = useState({});
  const [detail_items, setdetail_items] = useState([]); // detail_items 데이터 설정
  const [application_info, setApplication_info] = useState([]);
  const [, setMerchant_detail] = useState({}); // merchant_detail 데이터 설정
  const [generatedImage, setGeneratedImage] = useState(""); // 이미지 생성 코드 설정
  const [alert, setAlert] = useState("");
  const [progress, setProgress] = useState("");
  const [paidStatus, setPaidStatus] = useState(""); // 결제 상태 기본값 설정
  const [isMobile, setIsMobile] = useState(false);

  const [modal, setModal] = useState({
    addAmount: false,
    applicationType: false,
  });
  const [edit, setEdit] = useState({
    progress: false,
    markName: false,
    markType: false,
    applicationNumber: false,
    customerNumber: false,
  });
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });

  const [customerNumber, setCustomerNumber] = useState("");
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    message: "",
    onConfirm: null,
  });

  const { id } = useParams();
  const navigate = useNavigate();
  let prevent = false;
  const [payModal, setPayModal] = useState(false); // 결제 모달
  const [payEditModal, setPayEditModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [applyAgentPk, setApplyAgentPk] = useState("");
  const [userPk, setUserPk] = useState("");
  const [detailItems, setDetailItems] = useState([]);
  const [taxInvoiceType, setTaxInvoiceType] = useState();
  const [historyDetail] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const [applicantName, setApplicantName] = useState("");

  // 화면 크기 감지
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getApplyTypeStyle = (type) => {
    const baseStyle = {
      padding: "5px 10px",
      color: "white",
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "12px",
    };

    switch (type) {
      case "FAST":
        return { ...baseStyle, backgroundColor: "#3AB548" };
      case "SEARCH":
        return { ...baseStyle, backgroundColor: "#2EAEAE" };
      case "FASTSEARCH":
        return { ...baseStyle, backgroundColor: "#F66F6F" };
      case "NORMAL":
        return { ...baseStyle, backgroundColor: "#D08126" };
      default:
        return baseStyle;
    }
  };

  // 스타일 정의
  const styles = {
    container: {
      padding: "24px",
      paddingRight: isMobile ? "24px" : "380px", // FloatingList 공간 확보
      backgroundColor: "#f1f5f9",
      minHeight: "100vh",
    },
    contentWrap: {
      width: "100%",
      maxWidth: "100%",
    },
    header: detailPageStyles.header,
    title: detailPageStyles.title,
    idBadge: detailPageStyles.idBadge,
    section: detailPageStyles.section,
    sectionHeader: {
      padding: "16px 24px",
      borderBottom: "1px solid #e2e8f0",
      backgroundColor: "#f8fafc",
    },
    sectionTitle: detailPageStyles.sectionTitle,
    sectionContent: detailPageStyles.sectionContent,
    tableWrapper: detailPageStyles.tableWrapper,
    table: detailPageStyles.table,
    th: detailPageStyles.th,
    td: detailPageStyles.td,
    tdTitle: detailPageStyles.tdTitle,
    input: {
      width: "100%",
      padding: "8px 12px",
      fontSize: "14px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      backgroundColor: "#ffffff",
      color: "#1f2937",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      outline: "none",
    },
    select: {
      width: "100%",
      padding: "8px 12px",
      fontSize: "14px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      backgroundColor: "#ffffff",
      color: "#1f2937",
      outline: "none",
    },
    button: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      whiteSpace: "nowrap",
    },
    buttonSecondary: {
      backgroundColor: "#6b7280",
      color: "#ffffff",
    },
    buttonDanger: {
      backgroundColor: "#dc2626",
      color: "#ffffff",
    },
    buttonSuccess: {
      backgroundColor: "#059669",
      color: "#ffffff",
    },
    checkboxGroup: {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      marginBottom: "16px",
    },
    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
      color: "#374151",
      cursor: "pointer",
    },
    checkbox: listPageStyles.checkbox,
    urlBox: {
      cursor: "pointer",
      color: "#3b82f6",
      textDecoration: "underline",
      marginTop: "10px",
      padding: "8px 12px",
      backgroundColor: "#eff6ff",
      borderRadius: "6px",
      border: "1px solid #bfdbfe",
      transition: "all 0.2s ease",
    },
    statusBadge: {
      padding: "4px 12px",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "600",
      color: "#ffffff",
    },
    statusPending: {
      backgroundColor: "#f59e0b",
    },
    statusCompleted: {
      backgroundColor: "#10b981",
    },
    statusCanceled: {
      backgroundColor: "#ef4444",
    },
    buttonGroup: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
    },
    paymentMethodBadge: {
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
      backgroundColor: "#dbeafe",
      color: "#1d4ed8",
    },
  };

  useEffect(() => {
    if (info?.tax_invoice_type) {
      setTaxInvoiceType(info.tax_invoice_type);
    }
  }, [info?.tax_invoice_type]);

  useEffect(() => {
    if (detail_items?.length > 0) {
      const cleaned = detail_items?.map(({ detail_item_pk, ...rest }) => rest);
      setDetailItems(cleaned);
    }
  }, [detail_items]);

  const addDetailItem = (newItem) => {
    setDetailItems((prevItems) => {
      const exists = prevItems.some(
        (item) => item.mark_class === newItem.mark_class
      );

      if (exists) {
        return prevItems?.map((item) =>
          item.mark_class === newItem.mark_class ? newItem : item
        );
      } else {
        return [...prevItems, newItem];
      }
    });
  };
  const removeDetailItem = (mark_class) => {
    setDetailItems((prev) =>
      prev.filter((item) => item.mark_class !== mark_class)
    );
  };

  // 도장 다운로드 핸들러
  const handleStampGeneration = async () => {
    try {
      const response = await getStamp(id);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "image/jpeg",
      });

      const filename = `도장_${info_applicant?.name_kor}.jpg`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("도장 생성 오류:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "도장 생성 중 오류가 발생했습니다."
      );
    }
  };

  const getServerFileName = (type) => {
    switch (type) {
      case "stamp":
        return stampFilename;
      case "stamp_certificate":
        return stampCertificateFilename;
      case "biz_license":
        return bizLicenseFilename;
      default:
        return "";
    }
  };

  // 위임장 다운로드 핸들러
  const handleAttorneyGeneration = async () => {
    try {
      const response = await getAttorney(id);

      const contentType = response.headers["content-type"];
      const isJson = contentType && contentType.includes("application/json");

      if (isJson) {
        const text = await response.data.text();
        const errorJson = JSON.parse(text);
        throw new Error(errorJson.detail || "알 수 없는 오류");
      }

      // .docx MIME 타입으로 설정
      const blob = new Blob([response.data], {
        type:
          contentType ||
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // ✅ 내가 지정한 파일명 사용
      const filename = `위임장_${info_applicant?.name_kor}.docx`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("위임장 생성 오류:", error);

      if (error.response?.status === 422) {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "특허고객번호가 입력되지 않았습니다."
        );
      } else {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "위임장 생성 중 오류가 발생했습니다."
        );
      }
    }
  };

  const [, setPayemntInfo] = useState([]);
  const [editPayment, setEditPayment] = useState(null);
  const [editAddProduct, setEditAddProduct] = useState(false);

  // 추가 결제 내역 조회
  const getAddPaymentInfo = async () => {
    const result = await getAddPayment(id);
    if (typeof result === "object") {
      setPayemntInfo(result?.data);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 상세 정보 조회

  const [logoOriginalFileName, setLogoOriginalFileName] = useState("");
  const [logoFileName, setLogoFileName] = useState("");
  const [userId, setUserId] = useState("");
  const [, setLogoImagePath] = useState("");

  const [, setCompoundImageFilename] = useState("");

  const [stampFilename, setStampFilename] = useState("");
  const [, setStampOriginalFilename] = useState("");

  const [stampCertificateFilename, setStampCertificateFilename] = useState("");
  const [, setStampCertificateOriginalFilename] = useState("");

  const [bizLicenseFilename, setBizLicenseFilename] = useState("");
  const [, setBizLicenseOriginalFilename] =
    useState("");
  const [defaultFilenames, setDefaultFilenames] = useState({
    stamp: "",
    stamp_certificate: "",
    biz_license: "",
  });

  const getDetail = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => (prevent = false), 200);
    const result = await getAgenciesDetail(id);
    if (typeof result === "object") {
      setInfo(result?.data);
      setInfo_applicant(result?.data?.info_applicant); // 출원인 정보 설정
      setdetail_items(result?.data?.detail_items);
      setApplication_info(result?.data.application_info);
      setMerchant_detail(result?.data?.merchant_detail || []); // merchant_detail 데이터 설정
      setUserPk(result?.data?.id);
      setLogoOriginalFileName(result?.data?.image_original_filename);
      setLogoFileName(result?.data?.image_filename);
      setLogoImagePath(result?.data?.image_path);
      setMarkType(result?.data?.mark_type);
      setUserId(result?.data?.user_id);
      setApplicantName(result?.data?.info_applicant?.name_kor);
      setCompoundImageFilename(result?.data?.compound_image_filename);
      setOrderPk(result?.data?.order_pk);
      setStampFilename(result?.data?.info_applicant?.stamp_filename);
      setStampOriginalFilename(
        result?.data?.info_applicant?.stamp_original_filename
      );
      setStampCertificateFilename(
        result?.data?.info_applicant?.stamp_certificate_filename
      );
      setStampCertificateOriginalFilename(
        result?.data?.info_applicant?.stamp_certificate_original_filename
      );
      setBizLicenseFilename(result?.data?.info_applicant?.biz_license_filename);
      setBizLicenseOriginalFilename(
        result?.data?.info_applicant?.biz_license_original_filename
      );
      setDefaultFilenames({
        stamp: result?.data?.info_applicant?.stamp_original_filename || "",
        stamp_certificate:
          result?.data?.info_applicant?.stamp_certificate_original_filename ||
          "",
        biz_license:
          result?.data?.info_applicant?.biz_license_original_filename || "",
      });
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 진행 상태 수정
  const progressEditFn = async () => {
    changeState(setEdit, "progress", true);
    const result = await editProgress(id, progress);
    if (typeof result === "object") {
      setAlert("completeEdit");
      commonModalSetting(setAlertBox, true, "alert", "처리 되었습니다.");
      changeState(setEdit, "progress", false);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 결제 상태 수정
  const paidStatusEditFn = async () => {
    changeState(setEdit, "paidStatus", true);
    const result = await editPaidStatus(id, id, paidStatus);
    if (typeof result === "object") {
      setAlert("completeEdit");
      commonModalSetting(setAlertBox, true, "alert", "처리 되었습니다.");
      changeState(setEdit, "paidStatus", false);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 개인정보 파일 다운로드 함수
  const handleDownloadPrivacyFile = async (fileName, originalFileName) => {
    try {
      const blob = await downloadPrivacyFile(fileName, originalFileName);

      if (!(blob instanceof Blob)) {
        throw new Error("Response is not a Blob");
      }

      // 파일 다운로드handleDownload
      const url = window.URL.createObjectURL(blob); // 임시 파일 다운로드 링크 생성
      const a = document.createElement("a"); // 링크 요소 생성
      a.href = url; // 링크 요소의 href 속성 설정
      a.download = originalFileName; // 링크 요소의 download 속성 설정
      document.body.appendChild(a); // 링크 요소를 문서에 추가
      a.click(); // 링크 요소 클릭
      window.URL.revokeObjectURL(url); // 링크 요소 제거
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading privacy file:", error);
      // 에러 처리 (예: 알림 표시)
    }
  };

  // 특허고객번호 수정 함수 추가
  const customerNumberEditFn = async () => {
    const cleaned = customerNumber.replace(/-/g, "").trim();
    if (!cleaned) {
      return commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "특허고객번호를 입력해 주세요."
      );
    }

    if (!/^\d{12}$/.test(cleaned)) {
      return commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "특허고객번호는 숫자 12자리여야 합니다."
      );
    }

    try {
      const payload = {
        apply_agent_pk: id,
        patent_customer_number: cleaned,
      };

      const result = await addCustomerNumber(payload);

      if (typeof result === "object") {
        setAlert("completeEdit");
        commonModalSetting(setAlertBox, true, "alert", "처리 되었습니다.");
        changeState(setEdit, "customerNumber", false);
        getDetail();
      }
    } catch (error) {
      await catchError(error, navigate, setAlertBox, setAlert);
    }
  };

  // 수정된 코드
  useEffect(() => {
    // 상표명 수정 모달이 닫힐 때만 데이터를 새로 불러옴
    if (edit.markName === false) {
      getDetail();
    }
  }, [edit.markName]);

  useEffect(() => {
    // 상표 이미지 수정 모달이 닫힐 때만 데이터를 새로 불러옴
    if (edit.markImage === false) {
      getDetail();
    }
  }, [edit.markImage]);

  useEffect(() => {
    // 상표 유형 수정 모달이 닫힐 때만 데이터를 새로 불러옴
    if (edit.markType === false) {
      getDetail();
    }
  }, [edit.markType]);

  useEffect(() => {
    // 진행 상태 수정 모달이 닫힐 때만 데이터를 새로 불러옴
    if (edit.progress === false) {
      getDetail();
    }
  }, [edit.progress]);

  useEffect(() => {
    // 진행 상태 수정 모달이 닫힐 때만 데이터를 새로 불러옴
    if (edit.paidStatus === false) {
      getDetail();
    }
  }, [edit.paidStatus]);

  useEffect(() => {
    setProgress(info?.progress_status);
  }, [info?.progress_status]);

  useEffect(() => {
    setPaidStatus(info?.paid_status);
  }, [info?.paid_status]);

  useEffect(() => {
    const fetchImages = async () => {
      if (!info?.marks) return;

      let fileName = "";
      let originalName = "";

      if (info.mark_type === "FIGURE" || info.mark_type === "TEXT") {
        fileName = info.image_filename;
        originalName = info.image_original_filename;
      } else if (info.mark_type === "COMPOUND") {
        fileName = info.compound_image_filename;
        originalName = "복합상표";
      }

      if (fileName && originalName) {
        try {
          const url = await fetchUploadedImage(fileName, originalName);
          setGeneratedImage(url);
        } catch (error) {
          console.error("이미지 URL 가져오기 오류:", error);
        }
      }
    };

    fetchImages();
  }, [info]);

  const fetchUploadedImage = async (logoFileName, logoOriginalFileName) => {
    try {
      const response = await getResizeFileDownload(
        logoFileName,
        logoOriginalFileName
      );
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      const mimeType = response.headers["content-type"];
      return `data:${mimeType};base64,${base64}`;
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
      return null;
    }
  };

  const [orderPk, setOrderPk] = useState(null);

  const handleOriginalImgDownload = async () => {
    try {
      const res = await getFileDownload(
        info.image_filename,
        info.image_original_filename
      );
      const blob = new Blob([res.data], { type: res.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = info.image_original_filename || "downloaded_image";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("원본 이미지 다운로드 실패:", error);
    }
  };

  // useEffect 추가 - 특허고객번호 데이터 로드
  useEffect(() => {
    if (info_applicant?.patent_customer_number) {
      setCustomerNumber(info_applicant.patent_customer_number);
    }
  }, [info_applicant]);

  // 파일 업로드

  const [markNameArr, setMarkNameArr] = useState([]);
  const [markType, setMarkType] = useState("");
  const [, setFileName] = useState("");
  const [, setFile] = useState("");
  const [img, setImg] = useState("");
  const [imagePath] = useState("");
  const [, setUploadComplete] = useState(false);

  useEffect(() => {
    if (info?.marks?.length > 0) {
      const names = info.marks?.map((mark) => mark.mark_name || "");
      setMarkNameArr(names);
    }
  }, [info]);

  // 출원 정보 등록
  const [numberMoadl, setNumberModal] = useState(false);
  const markClassList = detail_items;


  const [, setMergedResult] = useState([]);
  const formatApplicationNumber = (value) => {
    const numeric = value.replace(/[^0-9]/g, "").slice(0, 13);

    if (numeric?.length <= 2) return numeric;
    if (numeric?.length <= 6)
      return `${numeric.slice(0, 2)}-${numeric.slice(2)}`;
    return `${numeric.slice(0, 2)}-${numeric.slice(2, 6)}-${numeric.slice(6)}`;
  };

  useEffect(() => {
    const combined = application_info?.map((app) => {
      const relatedDetails = detail_items.filter(
        (item) => item.agent_application_info_id === app.id
      );

      const markClasses = relatedDetails?.map((item) => item.mark_class);
      const detailItemPks = relatedDetails?.map((item) => item.detail_item_pk);

      return {
        id: app.id,
        application_number: formatApplicationNumber(app.application_number), // ✅ 포맷팅
        application_date: app.application_date,
        status: app.status,
        mark_class: markClasses,
        detail_item_pk: detailItemPks,
        files: app.files || [],
      };
    });

    setMergedResult(combined);
  }, [application_info, detail_items]);


  const fileInputRefs = useRef([]);

  const fileFields = [
    { label: "인감", type: "stamp" },
    { label: "인감 증명서", type: "stamp_certificate" },
    { label: "사업자 등록증", type: "biz_license" },
  ];

  const [files, setFiles] = useState({});

  const handleFileChange = async (type, file) => {
    setFiles((prev) => ({ ...prev, [type]: file }));

    const formData = new FormData();
    formData.append(type, file);

    try {
      const res = await getAgencyUploadFile(id, formData);
      console.log("업로드 성공", res);
    } catch (err) {
      console.error("업로드 실패:", err);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "파일 업로드에 실패했습니다."
      );
    }
  };

  const handleDelete = async (type) => {
    try {
      await deleteAgencyFile(id, type);

      setFiles((prev) => {
        const updated = { ...prev };
        delete updated[type];
        return updated;
      });

      setDefaultFilenames((prev) => ({
        ...prev,
        [type]: "", // 조회된 파일명도 제거
      }));

      if (fileInputRefs.current[type]) {
        fileInputRefs.current[type].value = null;
      }
    } catch (error) {
      console.error(error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "파일 삭제에 실패했습니다."
      );
    }
  };

  const [originalCustomerNumber, setOriginalCustomerNumber] = useState("");

  const [enterFloatSideBar, setEnterFloatSideBar] = useState(false);
  const [imageFloatSideBar, setImageFloatSideBar] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const options = [
    { label: "사업자등록증", value: "biz_license" },
    { label: "인감증명서", value: "stamp_certificate" },
    { label: "인감", value: "stamp" },
    { label: "기타", value: "etc" },
  ];

  const handleCheckboxChange = (value) => {
    setSelectedFiles((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const [tempUrl, setTempUrl] = useState("");
  // 파일 업로드 url
  const getUrlFunc = async () => {
    if (selectedFiles.length === 0) {
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "요청할 서류를 선택해주세요."
      );
      return;
    }
    try {
      const data = {
        user_pk: info.user_pk,
        require_files: selectedFiles,
        expires_in_days: 3,
      };
      const res = await createFileLink(data);
      setTempUrl(res?.data?.upload_url);
    } catch (err) {
      alert("업로드 실패");
      console.error(err);
    }
  };

  const handleCopyProducts = async (products, type) => {
    try {
      if (!products || products.length === 0) {
        setConfirmModal({
          isOpen: true,
          message: `복사할 ${type} 상품이 없습니다.`,
          onConfirm: () => setConfirmModal({ isOpen: false }),
        });
        return;
      }

      // 배열을 쉼표로 구분된 문자열로 변환
      const productString = products.join(",");

      // 클립보드에 복사
      await navigator.clipboard.writeText(productString);

      // 성공 메시지 표시
      setConfirmModal({
        isOpen: true,
        message: `${type} 상품이 클립보드에 복사되었습니다.`,
        onConfirm: () => setConfirmModal({ isOpen: false }),
      });
    } catch (error) {
      console.error("클립보드 복사 실패:", error);

      // 실패 시 대안 방법 (텍스트 선택)
      const textArea = document.createElement("textarea");
      textArea.value = products.join(",");
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      setConfirmModal({
        isOpen: true,
        message: `${type} 상품이 클립보드에 복사되었습니다.`,
        onConfirm: () => setConfirmModal({ isOpen: false }),
      });
    }
  };

  // 모든 상품 복사하기 함수
  const handleCopyAllProducts = async (noticeProducts, noneProducts) => {
    try {
      // 고시상품과 비고시상품을 합쳐서 하나의 배열로 만들기
      const allProducts = [...(noticeProducts || []), ...(noneProducts || [])];

      if (allProducts.length === 0) {
        setConfirmModal({
          isOpen: true,
          message: "복사할 상품이 없습니다.",
          onConfirm: () => setConfirmModal({ isOpen: false }),
        });
        return;
      }

      // 배열을 쉼표로 구분된 문자열로 변환
      const productString = allProducts.join(",");

      // 클립보드에 복사
      await navigator.clipboard.writeText(productString);

      // 성공 메시지 표시
      setConfirmModal({
        isOpen: true,
        message: "모든 상품이 클립보드에 복사되었습니다.",
        onConfirm: () => setConfirmModal({ isOpen: false }),
      });
    } catch (error) {
      console.error("클립보드 복사 실패:", error);

      // 실패 시 대안 방법 (텍스트 선택)
      const textArea = document.createElement("textarea");
      const allProducts = [...(noticeProducts || []), ...(noneProducts || [])];
      textArea.value = allProducts.join(",");
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      setConfirmModal({
        isOpen: true,
        message: "모든 상품이 클립보드에 복사되었습니다.",
        onConfirm: () => setConfirmModal({ isOpen: false }),
      });
    }
  };


  const [issued, setIssued] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setIssued(info?.tax_invoice_yn === "Y");
  }, [info?.tax_invoice_yn]);

  const handleChange = async (value) => {
    setIssued(value === "Y");
    setSaving(true);
    try {
      await editTaxInvoiceStatus(id, value === "Y");
    } catch (err) {
      console.error(err);
      // 실패 시 롤백
      setIssued((prev) => !prev);
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "세금계산서 발급 여부 저장에 실패했습니다."
        );
    } finally {
      setSaving(false);
    }
  };


  return (
    <>
      <div style={styles.container}>
        <div style={styles.contentWrap}>
          {/* Header */}
          <div style={styles.header}>
            <h1 style={styles.title}>
              <FileText size={32} />
              APPLICATION-DETAIL
              <span style={styles.idBadge}>ID: {id}</span>
            </h1>
          </div>

          {/* <div className="detail-page"> */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>추가 서류 요청</h2>
            </div>
            <div style={styles.sectionContent}>
              <div style={styles.checkboxGroup}>
                {options.map((opt) => (
                  <label key={opt.value} style={styles.checkboxLabel}>
                    <input
                      type="checkbox"
                      value={opt.value}
                      checked={selectedFiles.includes(opt.value)}
                      onChange={() => handleCheckboxChange(opt.value)}
                      style={styles.checkbox}
                    />
                    {opt.label}
                  </label>
                ))}
                <button style={styles.button} onClick={getUrlFunc}>
                  <ExternalLink size={16} />
                  url 생성하기
                </button>
              </div>
              {tempUrl && (
                <div
                  style={styles.urlBox}
                  onClick={() => {
                    navigator.clipboard.writeText(tempUrl);
                    setConfirmModal({
                      isOpen: true,
                      message: "URL이 복사되었습니다.",
                      onConfirm: () => setConfirmModal({ isOpen: false }),
                    });
                  }}
                  e
                >
                  <Copy
                    size={16}
                    style={{ display: "inline", marginRight: "8px" }}
                  />
                  {tempUrl}
                </div>
              )}
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>진행 및 결제 상태</h2>
            </div>
            <div style={styles.sectionContent}>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <colgroup>
                    <col width="15%" />
                    <col width="35%" />
                    <col width="15%" />
                    <col width="35%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        진행 상태
                      </td>
                      <td style={styles.td}>
                        {newStatusList[info?.progress_status]}
                      </td>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        진행 상태 변경
                      </td>
                      <td style={styles.td}>
                        <div style={styles.buttonGroup}>
                          <select
                            value={progress}
                            onChange={(e) => setProgress(e.target.value)}
                            style={styles.select}
                          >
                            {Object.keys(newStatusList)?.map((key, idx) => {
                              return (
                                <option
                                  value={key}
                                  className={key === "RegAbandon" ? "red" : ""}
                                >
                                  {Object.values(newStatusList)[idx]}
                                </option>
                              );
                            }, <></>)}
                          </select>
                          <button
                            style={styles.button}
                            onClick={() => {
                              setConfirmModal({
                                isOpen: true,
                                message:
                                  "고객님에게 상태 변경 이메일이 발송됩니다 <br /> 정말로 변경하시겠습니까?",
                                onConfirm: progressEditFn,
                              });
                            }}
                          >
                            처리
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        결제 상태
                      </td>
                      <td style={styles.td}>
                        {paidStatusList[info?.paid_status]}
                      </td>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        결제 상태 변경
                      </td>
                      <td style={styles.td}>
                        <div style={styles.buttonGroup}>
                          <select
                            value={paidStatus}
                            onChange={(e) => setPaidStatus(e.target.value)}
                            style={styles.select}
                          >
                            {Object.keys(paidStatusList)?.map((key) => (
                              <option value={key}>
                                {" "}
                                {paidStatusList[key]}{" "}
                              </option>
                            ))}
                          </select>
                          <button
                            style={styles.button}
                            onClick={paidStatusEditFn}
                          >
                            처리
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        입금자명
                      </td>
                      <td style={styles.td}>
                        {info?.toss_info?.length > 1
                          ? info?.toss_info.customer_name
                          : info?.paid_name}
                      </td>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        결제 방법
                      </td>
                      <td style={styles.td}>
                        {info?.paid_method === "toss"
                          ? `토스 결제 이용 - ${info?.toss_info?.method}${info?.toss_info?.payment_number
                            ? ` (${info?.toss_info.payment_number})`
                            : ""
                          }`
                          : info?.paid_method === "bank"
                            ? "무통장입금"
                            : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        신청인명
                      </td>
                      <td style={styles.td}>
                        {info?.user_name}({info?.user_id})
                      </td>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        결제 금액
                      </td>
                      <td style={styles.td}>
                        <div style={styles.buttonGroup}>
                          <p>{info?.merchant_price?.toLocaleString() || 0}원</p>
                          <button
                            style={{
                              ...styles.button,
                              ...styles.buttonSecondary,
                            }}
                            onClick={() => {
                              setUserPk(info?.user_pk);
                              setApplyAgentPk(id);
                              setPayEditModal(true);
                            }}
                          >
                            수정
                          </button>
                          {info?.paid_status !== "refund" && info?.paid_status !== "canceled" && (
                            <button
                              style={{
                                ...styles.button,
                                backgroundColor: "#dc2626",
                                color: "#ffffff",
                              }}
                              onClick={() => setRefundModal(true)}
                            >
                              환불
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                    {(info?.paid_status === "partial_refund" || info?.paid_status === "refund") && (
                      <tr>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          환불 금액
                        </td>
                        <td style={{ ...styles.td, color: "#dc2626", fontWeight: "600" }}>
                          {info?.refund_amount?.toLocaleString() || 0}원
                        </td>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          잔여 금액
                        </td>
                        <td style={{ ...styles.td, color: "#2563eb", fontWeight: "600" }}>
                          {info?.balance_amount?.toLocaleString() || 0}원
                        </td>
                      </tr>
                    )}
                    {info?.paid_method === "bank" && (
                      <tr>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          환불 계좌
                        </td>
                        <td style={styles.td} colSpan={3}>
                          {info?.refund_account_info ? (
                            <span style={{ fontWeight: "600" }}>
                              {info.refund_account_info.refund_bank_name}{" "}
                              {info.refund_account_info.refund_account}{" "}
                              ({info.refund_account_info.refund_holder})
                            </span>
                          ) : (
                            <span style={{ color: "#9ca3af" }}>
                              등록된 환불 계좌 없음
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                    {taxInvoiceType === "none" && (
                      <tr>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          세금계산서 발행 여부
                        </td>
                        <td style={styles.td} colSpan={3}>
                          신청 안함
                        </td>
                      </tr>
                    )}

                    {taxInvoiceType === "private" && (
                      <tr>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          세금계산서 신청 정보
                        </td>
                        <td style={styles.td} colSpan={3}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                            }}
                          >
                            <span>개인 발행</span>
                            <span>
                              핸드폰 번호: {info_applicant?.phone_number || "-"}
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}

                    {taxInvoiceType === "business" && (
                      <>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            세금계산서 신청 정보
                          </td>
                          <td style={styles.td} colSpan={3}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                              }}
                            >
                              <span>사업자 발행</span>
                              <span>
                                사업자등록번호: {info?.biz_regist_number || "-"}
                              </span>
                              <span>회사명: {info?.company || "-"}</span>
                              <span>소유주명: {info?.owner || "-"}</span>
                              <span>이메일: {info?.email || "-"}</span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <p>
                                  사업자 등록증 :{" "}
                                  {
                                    info_applicant?.biz_license_original_filename
                                  }
                                </p>
                                <button
                                  style={styles.button}
                                  onClick={() =>
                                    handleDownloadPrivacyFile(
                                      info_applicant?.biz_license_filename,
                                      info_applicant?.biz_license_original_filename
                                    )
                                  }
                                >
                                  다운로드
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </>
                    )}


                    {taxInvoiceType !== "none" && (
                      <tr>
                        <td style={{ ...styles.td, ...styles.tdTitle }}>
                          세금계산서 발급 여부
                        </td>
                        <td style={styles.td} colSpan={3}>
                          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                            <label style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <input
                                type="radio"
                                name={`taxInvoice-${applyAgentPk}`}
                                value="Y"
                                checked={issued === true}
                                disabled={saving}
                                onChange={() => handleChange("Y")}
                              />
                              발급(Y)
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <input
                                type="radio"
                                name={`taxInvoice-${applyAgentPk}`}
                                value="N"
                                checked={issued === false}
                                disabled={saving}
                                onChange={() => handleChange("N")}
                              />
                              미발급(N)
                            </label>
                          </div>
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>출원 신청 내역</h2>
            </div>
            <div style={styles.sectionContent}>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        출원 의뢰일자
                      </td>
                      <td style={styles.td} colSpan={3}>
                        {info.created_at?.replace("T", " ")}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ ...styles.td, ...styles.tdTitle }}
                        rowSpan={3}
                      >
                        출원 상표명(이미지)
                      </td>
                      <td style={styles.td} rowSpan={3}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <div>
                            <img
                              src={generatedImage}
                              alt="테스트 이미지"
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "contain",
                                border: "1px solid #e2e8f0",
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            {generatedImage && (
                              <button
                                style={styles.button}
                                onClick={() => {
                                  const link = document.createElement("a");
                                  link.href = generatedImage;
                                  link.download = "trademark_image.jpg";
                                  link.click();
                                }}
                              >
                                이미지 다운로드
                              </button>
                            )}
                            {info?.mark_type === "COMPOUND" && (
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() => handleOriginalImgDownload()}
                              >
                                원본 이미지 다운로드
                              </button>
                            )}
                            {info?.mark_type === "FIGURE" && (
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() => handleOriginalImgDownload()}
                              >
                                원본 이미지 다운로드
                              </button>
                            )}
                          </div>
                        </div>
                      </td>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        출원 상표명(텍스트)
                      </td>
                      <td style={styles.td}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          {markNameArr
                            .filter((name) => name)
                            .map((name, index) => (
                              <span
                                key={index}
                                style={{
                                  padding: "4px 8px",
                                  backgroundColor: "#f1f5f9",
                                  border: "1px solid #cbd5e1",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                }}
                              >
                                {name}
                              </span>
                            ))}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        상표 유형
                      </td>
                      <td style={styles.td}>
                        <span>
                          {info?.mark_type === "FIGURE"
                            ? "도형상표"
                            : info?.mark_type === "COMPOUND"
                              ? "복합상표"
                              : info?.mark_type === "TEXT"
                                ? "문자상표"
                                : ""}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.td, ...styles.tdTitle }}>
                        상표 설명
                      </td>
                      <td
                        style={{
                          ...styles.td,
                          whiteSpace: "pre-line",
                          wordBreak: "break-word",
                        }}
                      >
                        {info?.mark_description || ""}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ ...styles.td, ...styles.tdTitle }}
                        rowSpan={detailItems?.length ? detailItems?.length : 1}
                      >
                        상품/업종 및 출원 유형
                      </td>
                      <td style={styles.td} colSpan={3}>
                        {detailItems[0] ? (
                          (() => {
                            const {
                              mark_class,
                              apply_type,
                              notice_register_product,
                              none_register_product,
                            } = detailItems[0];

                            return (
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    marginBottom: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {mark_class}류
                                  </span>
                                  <span style={getApplyTypeStyle(apply_type)}>
                                    {apply_type === "NORMAL"
                                      ? "일반"
                                      : apply_type === "SEARCH"
                                        ? "조사"
                                        : apply_type === "FAST"
                                          ? "신속"
                                          : "신속조사"}
                                    출원
                                  </span>
                                  <button
                                    style={{
                                      ...styles.button,
                                      ...styles.buttonSecondary,
                                    }}
                                    onClick={() =>
                                      handleCopyAllProducts(
                                        notice_register_product,
                                        none_register_product
                                      )
                                    }
                                  >
                                    전체 상품 복사
                                  </button>
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      고시 상품 (
                                      {notice_register_product?.length})
                                    </span>
                                    <button
                                      style={{
                                        ...styles.button,
                                        ...styles.buttonSecondary,
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                      }}
                                      onClick={() =>
                                        handleCopyProducts(
                                          notice_register_product,
                                          "고시"
                                        )
                                      }
                                    >
                                      복사
                                    </button>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "4px",
                                    }}
                                  >
                                    {notice_register_product?.map(
                                      (e, index) => (
                                        <span
                                          style={{
                                            padding: "4px 8px",
                                            backgroundColor: "#dbeafe",
                                            border: "1px solid #93c5fd",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                          }}
                                          key={index}
                                        >
                                          {e}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </div>

                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      비고시 상품 (
                                      {none_register_product?.length})
                                    </span>
                                    <button
                                      style={{
                                        ...styles.button,
                                        ...styles.buttonSecondary,
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                      }}
                                      onClick={() =>
                                        handleCopyProducts(
                                          none_register_product,
                                          "비고시"
                                        )
                                      }
                                    >
                                      복사
                                    </button>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "4px",
                                    }}
                                  >
                                    {none_register_product?.map((e, index) => (
                                      <span
                                        style={{
                                          padding: "4px 8px",
                                          backgroundColor: "#fef3c7",
                                          border: "1px solid #fbbf24",
                                          borderRadius: "4px",
                                          fontSize: "12px",
                                        }}
                                        key={index}
                                      >
                                        {e}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })()
                        ) : (
                          <span style={{ color: "#6b7280" }}>없습니다</span>
                        )}
                      </td>
                    </tr>
                    {detailItems?.length > 1 &&
                      detailItems
                        .slice(1)
                        ?.map(
                          (
                            {
                              mark_class,
                              apply_type,
                              notice_register_product = [],
                              none_register_product = [],
                            },
                            idx
                          ) => (
                            <tr key={idx}>
                              <td style={styles.td} colSpan={3}>
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                      marginBottom: "16px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {mark_class}류
                                    </span>
                                    <span style={getApplyTypeStyle(apply_type)}>
                                      {apply_type === "NORMAL"
                                        ? "일반"
                                        : apply_type === "SEARCH"
                                          ? "조사"
                                          : apply_type === "FAST"
                                            ? "신속"
                                            : "신속조사"}
                                      출원
                                    </span>
                                    <button
                                      style={{
                                        ...styles.button,
                                        ...styles.buttonSecondary,
                                      }}
                                      onClick={() =>
                                        handleCopyAllProducts(
                                          notice_register_product,
                                          none_register_product
                                        )
                                      }
                                    >
                                      전체 상품 복사
                                    </button>
                                  </div>

                                  <div style={{ marginBottom: "16px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <span style={{ fontWeight: "bold" }}>
                                        고시 상품 (
                                        {notice_register_product?.length})
                                      </span>
                                      <button
                                        style={{
                                          ...styles.button,
                                          ...styles.buttonSecondary,
                                          padding: "4px 8px",
                                          fontSize: "12px",
                                        }}
                                        onClick={() =>
                                          handleCopyProducts(
                                            notice_register_product,
                                            "고시"
                                          )
                                        }
                                      >
                                        복사
                                      </button>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "4px",
                                      }}
                                    >
                                      {notice_register_product?.map(
                                        (e, index) => (
                                          <span
                                            style={{
                                              padding: "4px 8px",
                                              backgroundColor: "#dbeafe",
                                              border: "1px solid #93c5fd",
                                              borderRadius: "4px",
                                              fontSize: "12px",
                                            }}
                                            key={index}
                                          >
                                            {e}
                                          </span>
                                        )
                                      )}
                                    </div>
                                  </div>

                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <span style={{ fontWeight: "bold" }}>
                                        비고시 상품 (
                                        {none_register_product?.length})
                                      </span>
                                      <button
                                        style={{
                                          ...styles.button,
                                          ...styles.buttonSecondary,
                                          padding: "4px 8px",
                                          fontSize: "12px",
                                        }}
                                        onClick={() =>
                                          handleCopyProducts(
                                            none_register_product,
                                            "비고시"
                                          )
                                        }
                                      >
                                        복사
                                      </button>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "4px",
                                      }}
                                    >
                                      {none_register_product?.map(
                                        (e, index) => (
                                          <span
                                            style={{
                                              padding: "4px 8px",
                                              backgroundColor: "#fef3c7",
                                              border: "1px solid #fbbf24",
                                              borderRadius: "4px",
                                              fontSize: "12px",
                                            }}
                                            key={index}
                                          >
                                            {e}
                                          </span>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 출원인 정보 섹션 */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>출원인 정보</h2>
            </div>
            <div style={styles.sectionContent}>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  {/* 국내개인일 때 */}
                  {info?.applicant_type === "dom_indiv" && (
                    <>
                      <thead>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허 고객 구분
                          </td>
                          <td style={styles.td}>국내 개인</td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허고객번호
                          </td>
                          <td style={styles.td}>
                            {edit.customerNumber ? (
                              <div style={styles.buttonGroup}>
                                <input
                                  type="text"
                                  style={{
                                    ...styles.input,
                                    width: "200px",
                                  }}
                                  value={customerNumber}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (value?.length > 12)
                                      value = value.slice(0, 12);
                                    let formatted = value;
                                    if (value?.length > 0)
                                      formatted = value.slice(0, 1);
                                    if (value?.length > 1)
                                      formatted += "-" + value.slice(1, 5);
                                    if (value?.length > 5)
                                      formatted += "-" + value.slice(5, 11);
                                    if (value?.length > 11)
                                      formatted += "-" + value.slice(11, 12);

                                    setCustomerNumber(formatted);
                                  }}
                                  placeholder="특허고객번호 입력"
                                />
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSuccess,
                                  }}
                                  onClick={customerNumberEditFn}
                                >
                                  등록
                                </button>
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() => {
                                    setCustomerNumber(originalCustomerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      false
                                    );
                                  }}
                                >
                                  취소
                                </button>
                              </div>
                            ) : (
                              <div style={styles.buttonGroup}>
                                <div
                                  style={{
                                    width: "250px",
                                    height: "30px",
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    backgroundColor: "#888888",
                                    color: "#ffffff",
                                  }}
                                >
                                  {customerNumber || "특허고객번호 데이터 필요"}
                                </div>
                                <button
                                  style={styles.button}
                                  onClick={() => {
                                    setOriginalCustomerNumber(customerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      true
                                    );
                                  }}
                                >
                                  수정
                                </button>
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                marginTop: "12px",
                              }}
                            >
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 신청
                              </button>
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 확인
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            주민등록번호
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.social_security_number ||
                              info_applicant?.foreigner_register_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이름
                          </td>
                          <td style={styles.td}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                              }}
                            >
                              <span>(국문) {info_applicant?.name_kor}</span>
                              <span>(영문) {info_applicant?.name_eng}</span>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            등본상 주소
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.address}{" "}
                            {info_applicant?.detail_address} (
                            {info_applicant?.zip_code})
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이메일
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.email === "@"
                              ? ""
                              : info_applicant?.email}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            휴대전화
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.phone_number === "--"
                              ? ""
                              : info_applicant?.phone_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            유선전화
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.tel_number === "--"
                              ? ""
                              : info_applicant?.tel_number}
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                  {/* 국내법인일 때 */}
                  {info?.applicant_type === "dom_corp" && (
                    <>
                      <thead>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허 고객 구분
                          </td>
                          <td style={styles.td}>국내 법인</td>
                          <>
                            <td style={{ ...styles.td, ...styles.tdTitle }}>
                              특허고객번호
                            </td>
                            <td style={styles.td}>
                              {edit.customerNumber ? (
                                <div style={styles.buttonGroup}>
                                  <input
                                    type="text"
                                    style={{
                                      ...styles.input,
                                      width: "200px",
                                    }}
                                    value={customerNumber}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      );
                                      if (value?.length > 12)
                                        value = value.slice(0, 12);
                                      let formatted = value;
                                      if (value?.length > 0)
                                        formatted = value.slice(0, 1);
                                      if (value?.length > 1)
                                        formatted += "-" + value.slice(1, 5);
                                      if (value?.length > 5)
                                        formatted += "-" + value.slice(5, 11);
                                      if (value?.length > 11)
                                        formatted += "-" + value.slice(11, 12);

                                      setCustomerNumber(formatted);
                                    }}
                                    placeholder="특허고객번호 입력"
                                  />
                                  <button
                                    style={{
                                      ...styles.button,
                                      ...styles.buttonSuccess,
                                    }}
                                    onClick={customerNumberEditFn}
                                  >
                                    등록
                                  </button>
                                  <button
                                    style={{
                                      ...styles.button,
                                      ...styles.buttonSecondary,
                                    }}
                                    onClick={() => {
                                      setCustomerNumber(originalCustomerNumber);
                                      changeState(
                                        setEdit,
                                        "customerNumber",
                                        false
                                      );
                                    }}
                                  >
                                    취소
                                  </button>
                                </div>
                              ) : (
                                <div style={styles.buttonGroup}>
                                  <div
                                    style={{
                                      width: "250px",
                                      height: "30px",
                                      border: "1px solid #ccc",
                                      padding: "5px",
                                      backgroundColor: "#888888",
                                      color: "#ffffff",
                                    }}
                                  >
                                    {customerNumber ||
                                      "특허고객번호 데이터 필요"}
                                  </div>
                                  <button
                                    style={styles.button}
                                    onClick={() => {
                                      setOriginalCustomerNumber(customerNumber);
                                      changeState(
                                        setEdit,
                                        "customerNumber",
                                        true
                                      );
                                    }}
                                  >
                                    수정
                                  </button>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  marginTop: "12px",
                                }}
                              >
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() =>
                                    window.open(
                                      "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                      "_blank"
                                    )
                                  }
                                >
                                  특허고객번호 신청
                                </button>
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() =>
                                    window.open(
                                      "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                      "_blank"
                                    )
                                  }
                                >
                                  특허고객번호 확인
                                </button>
                              </div>
                            </td>
                          </>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 등록번호
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.corp_regist_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이름
                          </td>
                          <td style={styles.td}>
                            <div className="column">
                              <span>(국문) {info_applicant?.name_kor}</span>
                              <span>(영문) {info_applicant?.name_eng}</span>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            대표자 주민등록번호
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {
                              info_applicant?.representative_social_security_number
                            }
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            대표자 이름
                          </td>
                          <td style={styles.td}>
                            <span>{info_applicant?.representative_name}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            사업자 등록번호
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.biz_regist_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 대표 이메일
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.email === "@"
                              ? ""
                              : info_applicant?.email}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 대표 휴대전화
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.phone_number === "--"
                              ? ""
                              : info_applicant?.phone_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 대표 유선전화
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.tel_number === "--"
                              ? ""
                              : info_applicant?.tel_number}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            주소
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.address}{" "}
                            {info_applicant?.detail_address} (
                            {info_applicant?.zip_code})
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 인감
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.stamp_original_filename}
                            {info_applicant?.stamp_filename ? (
                              <button
                                onClick={() =>
                                  handleDownloadPrivacyFile(
                                    info_applicant?.stamp_filename,
                                    info_applicant?.stamp_original_filename
                                  )
                                }
                              >
                                다운로드
                              </button>
                            ) : (
                              "법인 인감파일 없음"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                  {/* 외국개인일 때 */}
                  {info?.applicant_type === "fgn_indiv" && (
                    <>
                      <thead>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허 고객 구분
                          </td>
                          <td style={styles.td}>외국 개인</td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허고객번호
                          </td>
                          <td style={styles.td}>
                            {edit.customerNumber ? (
                              <div style={styles.buttonGroup}>
                                <input
                                  type="text"
                                  style={{
                                    ...styles.input,
                                    width: "200px",
                                  }}
                                  value={customerNumber}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (value?.length > 12)
                                      value = value.slice(0, 12);
                                    let formatted = value;
                                    if (value?.length > 0)
                                      formatted = value.slice(0, 1);
                                    if (value?.length > 1)
                                      formatted += "-" + value.slice(1, 5);
                                    if (value?.length > 5)
                                      formatted += "-" + value.slice(5, 11);
                                    if (value?.length > 11)
                                      formatted += "-" + value.slice(11, 12);

                                    setCustomerNumber(formatted);
                                  }}
                                  placeholder="특허고객번호 입력"
                                />
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSuccess,
                                  }}
                                  onClick={customerNumberEditFn}
                                >
                                  등록
                                </button>
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() => {
                                    setCustomerNumber(originalCustomerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      false
                                    );
                                  }}
                                >
                                  취소
                                </button>
                              </div>
                            ) : (
                              <div style={styles.buttonGroup}>
                                <div
                                  style={{
                                    width: "250px",
                                    height: "30px",
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    backgroundColor: "#888888",
                                    color: "#ffffff",
                                  }}
                                >
                                  {customerNumber || "특허고객번호 데이터 필요"}
                                </div>
                                <button
                                  style={styles.button}
                                  onClick={() => {
                                    setOriginalCustomerNumber(customerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      true
                                    );
                                  }}
                                >
                                  수정
                                </button>
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                marginTop: "12px",
                              }}
                            >
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 신청
                              </button>
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 확인
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            외국인 등록번호
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.foreigner_register_number ||
                              "등록증 없음"}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이름
                          </td>
                          <td style={styles.td}>
                            <div className="column">
                              <span>(국문) {info_applicant?.name_kor}</span>
                              <span>(영문) {info_applicant?.name_eng}</span>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            국적
                          </td>
                          <td style={styles.td}>{info_applicant?.country}</td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이메일
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.email === "@"
                              ? ""
                              : info_applicant?.email}
                          </td>
                        </tr>

                        {info_applicant?.foreigner_register_card_yn === "y" && (
                          <>
                            <tr>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                주소
                              </td>
                              <td style={styles.td}>
                                {info_applicant?.address}{" "}
                                {info_applicant?.detail_address} (
                                {info_applicant?.zip_code})
                              </td>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                휴대전화
                              </td>
                              <td style={styles.td}>
                                {info_applicant?.phone_number === "--"
                                  ? ""
                                  : info_applicant?.phone_number}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                외국인 등록증
                              </td>
                              <td style={styles.td}>
                                {" "}
                                <div className="column">
                                  <span>
                                    외국인등록증 앞면 :
                                    {
                                      info_applicant?.foreigner_register_card_front_original_filename
                                    }
                                    {info_applicant?.foreigner_register_card_front_filename ? (
                                      <button
                                        onClick={() =>
                                          handleDownloadPrivacyFile(
                                            info_applicant?.foreigner_register_card_front_filename,
                                            info_applicant?.foreigner_register_card_front_original_filename
                                          )
                                        }
                                      >
                                        다운로드
                                      </button>
                                    ) : (
                                      "외국인 등록증 앞면 파일 없음"
                                    )}
                                  </span>
                                  <span>
                                    외국인등록증 뒷면 :
                                    {
                                      info_applicant?.foreigner_register_card_back_original_filename
                                    }
                                    {info_applicant?.foreigner_register_card_front_filename ? (
                                      <button
                                        onClick={() =>
                                          handleDownloadPrivacyFile(
                                            info_applicant?.foreigner_register_card_back_filename,
                                            info_applicant?.foreigner_register_card_back_original_filename
                                          )
                                        }
                                      >
                                        다운로드
                                      </button>
                                    ) : (
                                      "외국인 등록증 뒷면 파일 없음"
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                서명
                              </td>
                              <td style={styles.td}>
                                {" "}
                                <span>
                                  {info_applicant?.signature_original_filename}
                                  {info_applicant?.signature_filename ? (
                                    <button
                                      onClick={() =>
                                        handleDownloadPrivacyFile(
                                          info_applicant?.signature_filename,
                                          info_applicant?.signature_original_filename
                                        )
                                      }
                                    >
                                      다운로드
                                    </button>
                                  ) : (
                                    "서명 파일 없음"
                                  )}
                                </span>
                              </td>
                            </tr>
                          </>
                        )}
                        {info_applicant?.foreigner_register_card_yn === "n" && (
                          <>
                            <tr>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                해외 주소(영문)
                              </td>
                              <td style={styles.td}>
                                {info_applicant?.overseas_address}
                              </td>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                여권번호
                              </td>
                              <td style={styles.td}>
                                {info_applicant?.passport_number}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                여권사본
                              </td>
                              <td style={styles.td}>
                                <span>
                                  {info_applicant?.passport_original_filename}
                                  {info_applicant?.passport_filename ? (
                                    <button
                                      style={styles.button}
                                      onClick={() =>
                                        handleDownloadPrivacyFile(
                                          info_applicant?.passport_filename,
                                          info_applicant?.passport_original_filename
                                        )
                                      }
                                    >
                                      다운로드
                                    </button>
                                  ) : (
                                    "여권 파일 없음"
                                  )}
                                </span>
                              </td>
                              <td style={{ ...styles.td, ...styles.tdTitle }}>
                                서명
                              </td>
                              <td style={styles.td}>
                                <span>
                                  {info_applicant?.signature_original_filename}
                                  {info_applicant?.signature_filename ? (
                                    <button
                                      onClick={() =>
                                        handleDownloadPrivacyFile(
                                          info_applicant?.signature_filename,
                                          info_applicant?.signature_original_filename
                                        )
                                      }
                                    >
                                      다운로드
                                    </button>
                                  ) : (
                                    "서명 파일 없음"
                                  )}
                                </span>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </>
                  )}
                  {/* 외국법인일 때 */}
                  {info?.applicant_type === "fgn_corp" && (
                    <>
                      <thead>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허 고객 구분
                          </td>
                          <td style={styles.td}>외국 법인</td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허고객번호
                          </td>
                          <td style={styles.td}>
                            {edit.customerNumber ? (
                              <div style={styles.buttonGroup}>
                                <input
                                  type="text"
                                  style={{
                                    ...styles.input,
                                    width: "200px",
                                  }}
                                  value={customerNumber}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (value?.length > 12)
                                      value = value.slice(0, 12);
                                    let formatted = value;
                                    if (value?.length > 0)
                                      formatted = value.slice(0, 1);
                                    if (value?.length > 1)
                                      formatted += "-" + value.slice(1, 5);
                                    if (value?.length > 5)
                                      formatted += "-" + value.slice(5, 11);
                                    if (value?.length > 11)
                                      formatted += "-" + value.slice(11, 12);

                                    setCustomerNumber(formatted);
                                  }}
                                  placeholder="특허고객번호 입력"
                                />
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSuccess,
                                  }}
                                  onClick={customerNumberEditFn}
                                >
                                  등록
                                </button>
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() => {
                                    setCustomerNumber(originalCustomerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      false
                                    );
                                  }}
                                >
                                  취소
                                </button>
                              </div>
                            ) : (
                              <div style={styles.buttonGroup}>
                                <div
                                  style={{
                                    width: "250px",
                                    height: "30px",
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    backgroundColor: "#888888",
                                    color: "#ffffff",
                                  }}
                                >
                                  {customerNumber || "특허고객번호 데이터 필요"}
                                </div>
                                <button
                                  style={styles.button}
                                  onClick={() => {
                                    setOriginalCustomerNumber(customerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      true
                                    );
                                  }}
                                >
                                  수정
                                </button>
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                marginTop: "12px",
                              }}
                            >
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 신청
                              </button>
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 확인
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            대표자 이름(영문)
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.representative_name}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            이름
                          </td>
                          <td style={styles.td}>
                            <div className="column">
                              <span>(국문) {info_applicant?.name_kor}</span>
                              <span>(영문) {info_applicant?.name_eng}</span>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            국적
                          </td>
                          <td style={styles.td}>
                            <span>{info_applicant?.country}</span>
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 이메일
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.email === "@"
                              ? ""
                              : info_applicant?.email}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            법인 주소
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.overseas_address}
                          </td>

                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            대표자 서명
                          </td>
                          <td style={styles.td}>
                            <span>
                              {info_applicant?.signature_original_filename}
                              {info_applicant?.signature_filename ? (
                                <button
                                  onClick={() =>
                                    handleDownloadPrivacyFile(
                                      info_applicant?.signature_filename,
                                      info_applicant?.signature_original_filename
                                    )
                                  }
                                >
                                  다운로드
                                </button>
                              ) : (
                                "서명 파일 없음"
                              )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                  {/* 국가기관일 때 */}
                  {info?.applicant_type === "dom_inst" && (
                    <>
                      <thead>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허 고객 구분
                          </td>
                          <td style={styles.td}>국가기관</td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            특허고객번호
                          </td>
                          <td style={styles.td}>
                            {edit.customerNumber ? (
                              <div style={styles.buttonGroup}>
                                <input
                                  type="text"
                                  style={{
                                    ...styles.input,
                                    width: "200px",
                                  }}
                                  value={customerNumber}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (value?.length > 12)
                                      value = value.slice(0, 12);
                                    let formatted = value;
                                    if (value?.length > 0)
                                      formatted = value.slice(0, 1);
                                    if (value?.length > 1)
                                      formatted += "-" + value.slice(1, 5);
                                    if (value?.length > 5)
                                      formatted += "-" + value.slice(5, 11);
                                    if (value?.length > 11)
                                      formatted += "-" + value.slice(11, 12);

                                    setCustomerNumber(formatted);
                                  }}
                                  placeholder="특허고객번호 입력"
                                />
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSuccess,
                                  }}
                                  onClick={customerNumberEditFn}
                                >
                                  등록
                                </button>
                                <button
                                  style={{
                                    ...styles.button,
                                    ...styles.buttonSecondary,
                                  }}
                                  onClick={() => {
                                    setCustomerNumber(originalCustomerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      false
                                    );
                                  }}
                                >
                                  취소
                                </button>
                              </div>
                            ) : (
                              <div style={styles.buttonGroup}>
                                <div
                                  style={{
                                    width: "250px",
                                    height: "30px",
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    backgroundColor: "#888888",
                                    color: "#ffffff",
                                  }}
                                >
                                  {customerNumber || "특허고객번호 데이터 필요"}
                                </div>
                                <button
                                  style={styles.button}
                                  onClick={() => {
                                    setOriginalCustomerNumber(customerNumber);
                                    changeState(
                                      setEdit,
                                      "customerNumber",
                                      true
                                    );
                                  }}
                                >
                                  수정
                                </button>
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                marginTop: "12px",
                              }}
                            >
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 신청
                              </button>
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonSecondary,
                                }}
                                onClick={() =>
                                  window.open(
                                    "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                    "_blank"
                                  )
                                }
                              >
                                특허고객번호 확인
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            고유번호 <br /> (업자 등록번호)
                          </td>
                          <td style={styles.td}>
                            {info_applicant?.biz_regist_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            국가/공공 기관명
                          </td>
                          <td style={styles.td}>
                            <div className="column">
                              <span>(국문) {info_applicant?.name_kor}</span>
                              <span>(영문) {info_applicant?.name_eng}</span>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            주소
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.address}{" "}
                            {info_applicant?.detail_address} (
                            {info_applicant?.zip_code})
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            기관 대표 메일
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.email === "@"
                              ? ""
                              : info_applicant?.email}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            유선전화
                          </td>
                          <td style={styles.td}>
                            {" "}
                            {info_applicant?.tel_number === "--"
                              ? ""
                              : info_applicant?.tel_number}
                          </td>
                          <td style={{ ...styles.td, ...styles.tdTitle }}>
                            공인대장(기관인감)
                          </td>
                          <td style={styles.td}>
                            <span>
                              {info_applicant?.stamp_original_filename}
                              {info_applicant?.stamp_filename ? (
                                <button
                                  onClick={() =>
                                    handleDownloadPrivacyFile(
                                      info_applicant?.stamp_filename,
                                      info_applicant?.stamp_original_filename
                                    )
                                  }
                                >
                                  다운로드
                                </button>
                              ) : (
                                "공인대장 파일 없음"
                              )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                </table>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginTop: "24px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  style={styles.button}
                  onClick={handleAttorneyGeneration}
                >
                  <FileText size={16} />
                  위임장 생성
                </button>
                <button style={styles.button} onClick={handleStampGeneration}>
                  <FileText size={16} />
                  도장 생성
                </button>
                <button
                  style={{ ...styles.button, ...styles.buttonSecondary }}
                  onClick={() =>
                    window.open("https://www.remove.bg/ko/upload", "_blank")
                  }
                >
                  <ExternalLink size={16} />
                  도장 누끼
                </button>
              </div>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>파일 업로드</h2>
            </div>
            <div style={styles.sectionContent}>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  {fileFields.map(({ label, type }) => (
                    <tr key={type}>
                      <td
                        style={{
                          ...styles.td,
                          ...styles.tdTitle,
                          width: "35%",
                        }}
                      >
                        {label}
                      </td>
                      <td style={{ ...styles.td, width: "65%" }}>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              alignItems: "center",
                              marginBottom: "12px",
                            }}
                          >
                            {(files[type] || defaultFilenames[type]) && (
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#374151",
                                  padding: "4px 8px",
                                  backgroundColor: "#f3f4f6",
                                  borderRadius: "4px",
                                  border: "1px solid #d1d5db",
                                }}
                              >
                                업로드된 파일:{" "}
                                {files[type]?.name || defaultFilenames[type]}
                              </span>
                            )}

                            <label
                              htmlFor={`${type}Upload`}
                              style={{
                                display: "inline-block",
                                padding: "8px 12px",
                                backgroundColor: "#374151",
                                color: "#ffffff",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                                border: "none",
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              파일 선택
                            </label>
                          </div>

                          <input
                            id={`${type}Upload`}
                            type="file"
                            style={{ display: "none" }}
                            ref={(el) => (fileInputRefs.current[type] = el)}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                handleFileChange(type, file);
                                setDefaultFilenames((prev) => ({
                                  ...prev,
                                  [type]: "", // 새 파일 선택 시 기본 파일명 제거
                                }));
                              }
                            }}
                          />

                          {(files[type] || defaultFilenames[type]) && (
                            <div style={styles.buttonGroup}>
                              <button
                                style={{
                                  ...styles.button,
                                  ...styles.buttonDanger,
                                }}
                                onClick={() => handleDelete(type)}
                              >
                                <X size={16} />
                                파일 삭제
                              </button>
                              <button
                                style={styles.button}
                                onClick={() => {
                                  const fileName =
                                    files[type]?.name || defaultFilenames[type];
                                  const serverFileName =
                                    getServerFileName(type);
                                  if (serverFileName && fileName) {
                                    handleDownloadPrivacyFile(
                                      serverFileName,
                                      fileName
                                    );
                                  } else {
                                    alert("다운로드할 파일이 없습니다.");
                                  }
                                }}
                              >
                                <Download size={16} />
                                다운로드
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </div>

          {/* </div> */}
          {/* Floating Buttons */}
          <button
            style={{
              position: "fixed",
              bottom: "30px",
              right: isMobile ? "24px" : "400px",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#3b82f6",
              color: "#ffffff",
              border: "none",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "10px",
              fontWeight: "600",
              transition: "all 0.2s ease",
              zIndex: 1000,
              gap: "2px",
            }}
            onClick={() => setEnterFloatSideBar(true)}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
              e.target.style.backgroundColor = "#2563eb";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.backgroundColor = "#3b82f6";
            }}
          >
            <Edit size={20} />
            <span>입력</span>
          </button>

          <button
            style={{
              position: "fixed",
              top: "40px",
              right: isMobile ? "24px" : "380px",
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "#dc2626",
              color: "#ffffff",
              border: "none",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: "600",
              transition: "all 0.2s ease",
              zIndex: 1000,
              gap: "4px",
            }}
            onClick={() => setImageFloatSideBar(true)}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
              e.target.style.backgroundColor = "#b91c1c";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.backgroundColor = "#dc2626";
            }}
          >
            <Image size={24} />
            <span>
              이미지
              <br />
              생성
            </span>
          </button>
        </div>
      </div>
      <FloatingList type={"AGENT"} id={id} />
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else if (alert.includes("confirmDelete"))
              removeDetailItem(alert.split("/")[1]);
            else return;
          }}
        />
      )}
      {isDetailModalOpen && (
        <ApplyHistoryModal
          data={historyDetail}
          setIsDetailModalOpen={setIsDetailModalOpen}
        />
      )}
      {edit.markImage && (
        <MarkImageNameEditModal
          setEdit={setEdit}
          markType={markType}
          setOriginalFileName={setLogoOriginalFileName}
          fileName={logoFileName}
          setFile={setFile}
          setImg={setImg}
          setImagePath={setLogoFileName}
          setFileName={setFileName}
          originalFileName={logoOriginalFileName}
          setUploadComplete={setUploadComplete}
          imagePath={imagePath}
          defaultMarkNameArr={markNameArr}
          onMarkNameUpdated={(updated) => setMarkNameArr(updated)}
          setMarkType={setMarkType}
          img={img}
          id={id}
          setCompoundImageFilename={setCompoundImageFilename}
        />
      )}
      {modal.applicationType && (
        <AddApplicationTypeModal
          id={id}
          setModal={setModal}
          editAddProduct={editAddProduct}
          setEditAddProduct={setEditAddProduct}
          addDetailItem={addDetailItem}
          onSuccess={() => { }}
        />
      )}
      {confirmModal.isOpen && (
        <CommonModal
          setModal={setConfirmModal}
          modal={{
            mode: "confirm",
            context: confirmModal.message,
            bool: true,
          }}
          okFn={() => {
            confirmModal.onConfirm();
            setConfirmModal({ isOpen: false, message: "", onConfirm: null });
          }}
          cancelFn={() => {
            setConfirmModal({ isOpen: false, message: "", onConfirm: null });
          }}
        />
      )}
      {payModal && (
        <PaymentModal
          setPayModal={setPayModal}
          userPk={userPk}
          applyAgentPk={applyAgentPk}
          editData={editPayment}
          setEditData={setEditPayment}
          onSuccess={() => {
            getAddPaymentInfo();
          }}
        />
      )}
      {numberMoadl && (
        <ApplicationNumberModal
          setNumberModal={setNumberModal}
          markClassList={markClassList}
          id={id}
          onSuccess={() => {
            getDetail();
          }}
        />
      )}
      {enterFloatSideBar && (
        <ApplicationForm
          setEnterFloatSideBar={setEnterFloatSideBar}
          pkUserId={userId}
          alreadyApplicantName={applicantName}
          customerNumber={customerNumber}
          markNameArr={markNameArr}
        />
      )}
      {imageFloatSideBar && (
        <ImageGenerateFloat setImageFloatSideBar={setImageFloatSideBar} />
      )}
      {payEditModal && (
        <PaymentEditModal
          setPayEditModal={setPayEditModal}
          id={orderPk}
          onSuccess={() => {
            getDetail();
          }}
        />
      )}
      {refundModal && (
        <RefundModal
          info={info}
          onClose={() => setRefundModal(false)}
          onSuccess={() => {
            getDetail();
          }}
        />
      )}
      <FloatingList type={"AGENT"} id={id} />
    </>
  );
};

export default ApplicationDetail;
